import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, MaterialIcons } from '@iclinic/design-system';

import * as S from './CFMAlert.style';
import { open, close } from '../../state';
import { useCFMSteps } from 'features/CFMUpdate/hooks/useCFMSteps';

const { WarningAmberOutlined } = MaterialIcons;

export default function CFMAlert() {
  const dispatch = useDispatch();

  const handleClose = () => dispatch(close());
  const steps = useCFMSteps(handleClose);

  const handleOpenModal = () => {
    dispatch(open({ steps: steps ?? {} }));
  };

  return (
    <Box my={2}>
      <S.Alert
        severity="warning"
        elevation={0}
        icon={<WarningAmberOutlined />}
        message="Olá, para continuar emitindo NFe e manter o seu acesso ao sistema, atualize seus dados cadastrais."
        action={
          <Button onClick={handleOpenModal} size="large" color="transparent">
            Atualizar dados
          </Button>
        }
      />
    </Box>
  );
}
